import { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { ApiException } from '../api/client';
import { useAuth } from '../contexts/AuthContext';
import { Alert } from '../components/Alert';
import { Button } from '../components/Button';
import { AccentCard } from '../components/Card';
import { Input } from '../components/Input';
import { AuthLayout } from '../components/Layout';

export function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const [usernameOrEmail, setUsernameOrEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  // Setelah login sukses, redirect ke halaman yang diminta sebelumnya (kalau ada)
  const fromPath = (location.state as { from?: Location } | null)?.from?.pathname ?? '/dashboard';

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await login({ usernameOrEmail: usernameOrEmail.trim(), password });
      navigate(fromPath, { replace: true });
    } catch (err) {
      setError(err instanceof ApiException ? err.message : 'Terjadi kesalahan tak terduga.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout>
      <AccentCard title="Login Booku Client" subtitle="Masuk ke akun Anda">
        {error && (
          <div className="mb-4">
            <Alert variant="error">{error}</Alert>
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <Input
            label="Username atau Email"
            name="usernameOrEmail"
            value={usernameOrEmail}
            onChange={(e) => setUsernameOrEmail(e.target.value)}
            required
            autoComplete="username"
            disabled={loading}
          />
          <Input
            label="Password"
            name="password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            autoComplete="current-password"
            disabled={loading}
          />
          <div className="text-right">
            <Link to="/forgot-password" className="text-xs text-booku-primary hover:underline">
              Lupa password?
            </Link>
          </div>
          <Button type="submit" variant="primary" fullWidth loading={loading}>
            Masuk
          </Button>
        </form>

        <div className="mt-6 text-center text-sm text-gray-600">
          Belum punya akun?{' '}
          <Link to="/register" className="text-booku-primary font-medium hover:underline">
            Daftar
          </Link>
        </div>
      </AccentCard>
    </AuthLayout>
  );
}
